import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { apiData } from "../../../actions";
import DataLoader from "../../../Utils/DataLoader";
import roundedshapewhite from '../../../assets/images/rounded-shape-white.svg';

export default function AdventuresSlug() {
  const [blogs, setBlogs] = useState([]);
  const [keyword, setKeyword] = useState("");
  const [pageLoading, setPageLoading] = useState(true);

  const place = useSelector((state) => state.place);

  const LoadMore = async () => {
    try {
      setPageLoading(true);

      const payload = {
        city: place,
        keyword: "Adventure",
        limit: 12
      };
      let apiRes = await apiData.getRandomDeals(payload);

      if (apiRes?.status >= 200 && apiRes?.status <= 399) {
        const data = apiRes?.data?.data || [];
        setBlogs(data);
      } else {
        console.log("Server Error");
      }
    } catch (err) {
      console.log("Blog Loading Error:", err);
    } finally {
      setPageLoading(false);
    }
  };

  useEffect(() => {
    LoadMore();
  }, [keyword, place]);

  if (pageLoading) return <DataLoader />;

  return (
    <section className="section-equal-padding bg-white">
      <div className="row gy-4">
        {blogs.map((ele, index) => (
          <div
            key={index}
            className="col-12 col-sm-12 col-md-6 col-lg-4 col-xxl-3 mb-4 mb-lg-0"
          >
            <div
              className="blog-card"
              uk-scrollspy="cls: uk-animation-slide-bottom; delay: 400; repeat: false"
            >
              <figure>
                <img
                  loading="lazy"
                  src={ele?.image}
                  alt={ele?.title}
                />
              </figure>
              <div className="resorts-content-box-slug-cruises w-100 text-center">
                <h3>{ele?.title?.length > 25
                  ? ele.title.slice(0, 80) + "..."
                  : ele.title}</h3>
              </div>

              <div className="blog-link">
                <span className="top-left">
                  <img src={roundedshapewhite} alt="roundedshapewhite" />
                </span>
                <span className="bottom-right">
                  <img src={roundedshapewhite} alt="roundedshapewhite" />
                </span>

                <a href={ele?.link} target="_blank" rel="noreferrer">
                  <i className="fa-solid fa-arrow-right"></i>
                </a>
              </div>
            </div>
          </div>
        ))}
      </div>

    </section>
  );
}
